import React from 'react';
import { outBoundCall } from '../../Images/Images'
import { hidePhone } from '../../js/helpers/Utils/formats';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { UncontrolledTooltip } from 'reactstrap';

var index = 0;
export const CUSTOM_CELLS = {
  cellImageText: (item, parameters, cellStyles, selectCell, isHidePhone) => {
    return <li key={"key" + (index++)} className={("cellImageText " + cellStyles)} onClick={() => {
      if (selectCell) { selectCell(item); }
    }}>
      <img className="cellImage" src={item[parameters["image"]]} alt="icon"></img>
      <p className="cellText">{hidePhone(isHidePhone, item[parameters["text"]])}</p>
    </li>
  },
  cellText: (item, parameters, cellStyles, selectCell) => {
    return <li key={"key" + (index++)} className={("cellOnlyText " + cellStyles)} onClick={() => { if (selectCell) { selectCell(item) } }}>
      <p className="cellText">{parameters ? item[parameters["text"]] : item}</p>
    </li>
  },
  cellAssignedCallback: (item, parameters, cellStyles, selectCell) => {
    return <li key={"key" + (index++)} className={("cellAssignedCallback " + cellStyles)} onClick={() => selectCell(item)}>
      <p className="timeAssignedCall"><a className="bulletBlue">&#9679;</a>{item[parameters["time"]]}</p>
      <div className="phoneNumberContainer">
        <img className="iconPhoneNumber" src={item[parameters["iconPhoneNumber"]]} alt="icon"></img>
        <p className="textPhoneNumber">{item[parameters["phoneNumber"]]}</p>
      </div>
      <p className="campaignName">{item[parameters["campaignName"]]}</p>
    </li>
  },
  cellMark: (item, parameters, cellStyles, selectCell) => {
    return <li key={"key" + (index++)} className={("cellMark " + cellStyles)} onClick={() => selectCell(item)}>
      <p>{item[parameters["tiempoX"]]}</p>
    </li>
  },
  cellACDTransfer: (item, parameters, cellStyles, selectCell) => {
    return <li className={("transferCell " + cellStyles)} key={"transferCell" + (index++)} onClick={() => selectCell(item)}>
      <p className={item[parameters["id"]] !== -1 ? "orange" : ""}>{item[parameters["name"]]}</p>
    </li>
  },
  cellAgentTransfer: (item, parameters, cellStyles, selectCell) => {
    var namesAgent = item[parameters["name"]].split(' ');
    return <li className={("transferCell " + cellStyles)} key={"transferCell" + (index++)} onClick={() => selectCell(item)}>
      <p >{namesAgent[0] + " / "} <span className="black60">{namesAgent[1]}</span></p>
    </li>
  },
  cellPhoneTransfer: (item, parameters, cellStyles, selectCell) => {
    var name = null;
    if (parameters["name"] && item[parameters["name"]]) {
      let names = item[parameters["name"]].split('|');
      name = names[1];
    }
    name = name || item[parameters["phone"]];
    return <li className={("transferCell " + cellStyles)} key={"transferCell" + (index++)} onClick={() => selectCell(item)}>
      <p >{name}</p>
    </li>
  },

  cellCampaings: (item, parameters, cellStyles, selectCell, favCampaing) => {
    return (
			<OverlayTrigger
				key={`tlt-notificationContainer-cellCampaing-${index++}`}
				placement='bottom'
				overlay={
					<Tooltip className='notificationContainer-tooltip bottom show cellCampaing' key={`notificationContainer-tooltip-cellCampaing-${index++}`} id={`notificationContainer-tooltip-cellCampaingId-${index++}`}>
						{item[parameters['name']]}
					</Tooltip>
				}>
				<li key={'cellCampaing' + index++} className='campaingCell' onClick={() => selectCell(item)}>
					<img className='iconCampaingCell' src={outBoundCall} alt='icon'></img>
					<img className='iconCampaingCell iconCampaingPadding' src={item[parameters['imgCampaing']]} alt='icon'></img>
					<p className='infoCampaingCell'>{item[parameters['name']]}</p>
				</li>
				{/* <div className={"favSelected "+(item[parameters["isFav"]] ? "fav":"")} onClick={(evt)=>favCampaing(evt,item)}>{ item[parameters["starFav"]] }</div> */}
			</OverlayTrigger>
		);
  },
  cellDirectory: (item, parameters, cellStyles, selectCell) => {
    return <li key={"cellCampaing" + (index++)} className="manualCallDataCell info" onClick={() => selectCell(item)}>
      <p className="manualCallCell">{item[parameters["name"]]}</p>
      <p className="manualCallCell">{item[parameters["phone"]]}</p>
      <p className="manualCallCell">{item[parameters["callKey"]]}</p>
    </li>;
  },
  cellDirectoryByCallKey: (item, parameters, cellStyles, selectCell) => {
    return <li key={"cellCampaing" + (index++)} className="manualCallDataCell info" onClick={() => selectCell(item)}>
      <p className="manualCallCell">{item[parameters["callKey"]]}</p>
      <p className="manualCallCell">{item[parameters["name"]]}</p>
      <p className="manualCallCell">{item[parameters["phone"]]}</p>
    </li>;
  },
  cellRecordCall: (item, parameters, cellStyles, selectCell, _, onDoubleClick, ind) => {
    let sharedData = new SingletonSharedData(); 
    return <li key={"cellRecordCall" + (index++)} className={("cellRecordCall " + cellStyles)} onClick={() => selectCell(item)} onDoubleClick={onDoubleClick}>
      {parameters.Hour && <p className="itemRecordCall" style={{ width: parameters.Hour.size }}>{item.Hour}</p>}
      {parameters.Telephone && <p className="itemRecordCall" style={{ width: parameters.Telephone.size }}>{hidePhone(sharedData.getGeneralPermissions()[223],item.Telephone)}</p>}
      {parameters.Duration && <p className="itemRecordCall" style={{ width: parameters.Duration.size }}>{item.Duration}</p>}
      {parameters.CallKey && <p className="itemRecordCall simple" style={{ width: parameters.CallKey.size }}>{item.CallKey}</p>}
      {parameters.Description && <div className="itemRecordCall" style={{ width: parameters.Description.size }}>
        <img className="iconRecordCall" src={item["imageBackItem"]} alt="icon"></img>
        <img className="iconRecordCall iconRecordCallPadding" src={item["imageItem"]} alt="icon"></img>
        <p className="descriptionRecordCall">{item.Description}</p>
      </div>}
      {parameters.Disposition && <p className="dispositionRecordCall" style={{ width: parameters.Disposition.size }} id={'record-calification-name-' + ind}>{item.Disposition}</p>}
      {parameters.Disposition && item.Disposition.length > 20 && (
        <UncontrolledTooltip delay={{ show: 500, hide: 100 }} placement='top' target={'record-calification-name-' + ind} boundariesElement={'window'} className='gcl-agent-info-tooltip'>
          {item.Disposition}
        </UncontrolledTooltip>
      )}
      
    </li>;
  },
};



// WEBPACK FOOTER //
// ./src/js/customElements/customCell.js